module.exports = __webpack_public_path__ + "img/side seam.36ed7b16.png";